// ANALYTICS - TRACKERS
import { init as initHome } from './../trackers/homepage/home-tracker';
import { init as initSportsAdvice } from './../trackers/homepage/sports-advice-tracker';
// SHOPPING TOOL
import { init as initStHomepage } from './../shopping-tool/st-homepage';
// ENHANCED E-COMMERCE
import { init as initEcImpressionHp } from './../enhanced/ec-1-impression-hp';
import { init as initEcClickHp } from './../enhanced/ec-2-click-hp';

export const init = () => {
  if ( window.cube.config.anly_useLegacy === 'Y') {
    // Initialisation des trackers
    if ($('body').hasClass('homepage')) {
      initHome();
      initSportsAdvice();
    }
    //   // Init Shopping tools
    initStHomepage();

    // Init Enhanced e-Commerce
    initEcImpressionHp();
    initEcClickHp();
  }
};



// WEBPACK FOOTER //
// ./src/analytics/routes/homepage.anly.route.js